import { Image } from "@components/Image/Image";
import React from "react";
import { withVideo } from "./withVideo";

import ReactPlayer from "react-player";

export const Video = withVideo(({ playing, video, videoBackground, muted }) => (
  <div className="relative h-full w-full">
    <ReactPlayer
      controls={false}
      loop={true}
      playing={playing}
      muted={muted}
      playsinline={true}
      url={video?.url}
      width="100%"
      height="100%"
    />
    <Image image={videoBackground} alt={videoBackground?.alt} />
  </div>
));
